import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setIsLoggedIn } from '../../../../features/account/account.slice';

const EditEmailForm = ({ closeModal, setVerificationEmail, currentEmail, setServerMessage, emailVerified }) => {
  const [email, setEmail] = useState('');
  const [confirmEmail, setConfirmEmail] = useState('');
  const [showResendOption, setShowResendOption] = useState(false);
  const [processing, setProcessing] = useState(false);

  const apiUrl = process.env.REACT_APP_API_BASE_URL

  const dispatch = useDispatch();

  const emailValidation = (email) => {
    // Basic email validation regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // const handleResendVerification = async () => {
  //   try {
  //     const response = await fetch(`${apiUrl}/user/resend-verification-email`, {
  //       method: 'POST',
  //       credentials: 'include',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({ email: currentEmail }),
  //     });

  //     const data = await response.json();

  //     if (data.success) {
  //       setServerMessage({ success: true, message: 'A verification link has been resent to your current email address. Please check your inbox or spam folder.' });
  //     } else {
  //       setServerMessage({ success: false, message: data.message || 'Failed to resend verification email.' });
  //     }
  //   } catch (error) {
  //     console.error('Error resending verification email:', error);
  //     setServerMessage({ success: false, message: 'An error occurred while resending the verification email.' });
  //   }
  // };

  const setNewEmail = async (newEmail) => {

    try {
      const response = await fetch(`${apiUrl}/user/send-verification-email`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: newEmail, type: 'emailChange' }),
      });

      if (response.status === 401) {
        // Unauthorized, possibly session expired
        dispatch(setIsLoggedIn(false)); // Redux update will clear user data and redirect to login
        return;
      };

      const data = await response.json();

      if (data.success) {
        setVerificationEmail(newEmail);
        setServerMessage({ success: true, message: 'A verification link has been sent to your new email address. Please check your inbox or spam folder.' });
        closeModal();
        setEmail(''); // Clear the email input field
      } else {
        setServerMessage({ success: false, message: data.message || 'Failed to send verification email.' });
      }
    } catch (error) {
      console.error('Error sending verification email:', error);
      setServerMessage({ success: false, message: 'An error occurred while sending the verification email.' });
    }
  };

  const onSubmit = async () => {

    setProcessing(true);

    if (!email || !confirmEmail) {
      setServerMessage({ success: false, message: 'Please fill in both email fields.' });
      setProcessing(false);
      return;
    }

    const isValidEmail = emailValidation(email);
    if (!isValidEmail) {
      setServerMessage({ success: false, message: 'Please enter a valid email address.' });
      setProcessing(false);
      return;
    }
    
    if (email === currentEmail) {
      setServerMessage({ success: false, message: 'This is already your current email address. Please enter a new email if you want to change it.' });
      setProcessing(false);
      return;
    }

    if (email !== confirmEmail) {
      setServerMessage({ success: false, message: 'Email addresses do not match. Please confirm your new email address.' });
      setProcessing(false);
      return;
    }

    // OLD LOGIC TO CHECK CURRENT EMAIL
    // if (email === currentEmail) {
    //   if (!emailVerified) {
    //     setShowResendOption(true); // Show the resend option if the email is not verified
    //     setServerMessage({ success: false, message: 'This email is already in use but not verified. You can resend the verification link below.' });
    //   } else {
    //     setServerMessage({ success: false, message: 'This is already your current verified email address. Please enter a new email if you want to change it.' });
    //   }
    //   return;
    // }

    await setNewEmail(email);
    setProcessing(false);
  };

  return (
    <div className=''>
      <h4 className='ms-1 mb-3'>Change Email</h4>
      <input
        className="custom-input rounded mb-3"
        type="email"
        placeholder="New email address"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        onFocus={(e) => (e.target.style.borderColor = '#FFCC19')} // Change border color on focus
        onBlur={(e) => (e.target.style.borderColor = '#3C3E4C')} // Reset border color on blur
        style={{
          height: '45px',
          backgroundColor: '#171A29',
          width: '100%', // Ensure the input takes the full width of the container
          paddingRight: '40px', // Add padding to make space for the icon
          border: '1px solid #3C3E4C',
          color: 'white',
        }}
      />
      <input
        className="custom-input rounded"
        type="email"
        placeholder="Confirm new email address"
        value={confirmEmail}
        onChange={(e) => setConfirmEmail(e.target.value)}
        onFocus={(e) => (e.target.style.borderColor = '#FFCC19')} // Change border color on focus
        onBlur={(e) => (e.target.style.borderColor = '#3C3E4C')} // Reset border color on blur
        style={{
          height: '45px',
          backgroundColor: '#171A29',
          width: '100%', // Ensure the input takes the full width of the container
          paddingRight: '40px', // Add padding to make space for the icon
          border: '1px solid #3C3E4C',
          color: 'white',
        }}
      />
      {/* {showResendOption && !emailVerified && (
        <p className='mt-2 ms-1' style={{ fontSize: '16px', color: '#A4A4B7' }}>
          If you believe this email is correct but not verified,{' '}
          <span style={{ color: '#FFCC19', cursor: 'pointer' }} onClick={handleResendVerification}>
            click here
          </span>{' '}
          to resend the verification link.
        </p>
      )} */}

      <p className='mt-2 ms-1' style={{ fontSize: '16px', color: '#A4A4B7' }}>
        A verification link will be sent to this email address. Please check your inbox or spam folder to confirm the change.
      </p>
      <div className='d-flex justify-content-center align-items-center mt-4'>
        <button
          className='rounded w-100'
          style={{ backgroundColor: '#FFCC19', height: '45px', fontWeight: 600, border: "none", color: "black" }}
          onClick={onSubmit}
          disabled={processing}
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default EditEmailForm;